import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWest = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.3 18.3L2.7 12.7C2.6 12.6 2.52934 12.4917 2.488 12.375C2.446 12.2584 2.425 12.1334 2.425 12C2.425 11.8667 2.446 11.7417 2.488 11.625C2.52934 11.5084 2.6 11.4 2.7 11.3L8.3 5.70005C8.48334 5.51672 8.71267 5.42505 8.988 5.42505C9.26267 5.42505 9.5 5.51672 9.7 5.70005C9.9 5.90005 10 6.13738 10 6.41205C10 6.68738 9.9 6.92505 9.7 7.12505L5.825 11H21C21.2833 11 21.5207 11.0957 21.712 11.287C21.904 11.479 22 11.7167 22 12C22 12.2834 21.904 12.5207 21.712 12.712C21.5207 12.904 21.2833 13 21 13H5.825L9.7 16.9C9.88334 17.0834 9.97934 17.3124 9.988 17.587C9.996 17.8624 9.9 18.1 9.7 18.3C9.51667 18.4834 9.28334 18.575 9 18.575C8.71667 18.575 8.48334 18.4834 8.3 18.3Z",
		fill: "currentColor"
	})
});
export default SvgWest;
